/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotMembers {
    getFixupPrototypeFunction() { return CopilotMembers.fixupPrototype; }

    static newInstance(model: Partial<CopilotMembers>): CopilotMembers {
        let obj = Object.assign(new CopilotMembers(), model);
        CopilotMembers.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotMembers>): CopilotMembers {
        if (!model) return null;
        return CopilotMembers.newInstance(<CopilotMembers> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotMembers) {
        if (!obj) return;

        models.CopilotMembers.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotMembers): boolean {
        Object.setPrototypeOf(obj, CopilotMembers.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.touched_at === "string") {
            this.touched_at = new Date(<string><any>this.touched_at);
        }
        if (typeof this.last_active_at === "string") {
            this.last_active_at = new Date(<string><any>this.last_active_at);
        }
    }

    /**
     * Service account the member belongs to
     */
    service_account_id: string;

    /**
     * GitHub username of the member
     */
    github_username: string;

    /**
     * GitHub user ID of the member
     */
    github_user_id: string;

    /**
     * Timestamp when the member record was created
     */
    created_at: Date;

    /**
     * Timestamp when the member record was last updated
     */
    touched_at: Date;

    /**
     * Timestamp when the member was last active
     */
    last_active_at: Date;

    /**
     * Copilot plan type assigned to the member
     */
    plan_type: string;

    /**
     * Whether the member belongs to the organization
     */
    is_member: boolean;

}
